/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react'

type useTextProps = {
  trim?: boolean
}

export const useText = (
  initial: string = '',
  props: useTextProps = {}
): [string, (e: React.SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void, () => void] => {
  const [text, setText] = React.useState(initial)

  const onChange = (e: React.SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    let value = e.currentTarget.value
    if (props.trim) {
      value = value.trim()
    }
    return setText(value)
  }

  return [text, onChange, () => setText('')]
}

export const useUpdateNotSupported = (params: React.DependencyList): void => {
  if (process.env.NODE_ENV === 'development') {
    const renderCountRef = React.useRef(0)
    React.useEffect(() => {
      renderCountRef.current++
      if (renderCountRef.current > 1) {
        throw new Error('Watch params changed, component does not currently support watchparam changing')
      }
    }, params)
  }
}

export const useEffectAfterMount = (func: React.EffectCallback, deps: React.DependencyList) => {
  const didMount = React.useRef(false)

  React.useEffect(() => {
    if (didMount.current) {
      return func()
    }
    didMount.current = true
  }, deps)
}
